import { ContextMenuItem } from "./ContextMenuItem";

class KeyMenuItem {
    hasCtrl?: boolean;
    hasAlt?: boolean;
    hasShift?: boolean;
    keys?: string[];
    contextMenuItem: ContextMenuItem;
}

export default KeyMenuItem;